import { Payload } from "@neworbit/redux-helpers";
import { loadAndTrack } from "redux-request-loading";

import { Dispatch } from "redux";

import { ClinicType } from "../models";
import { clinicApi } from "../clinicApi";

import * as actionTypes from "./actionTypes";

export type ClinicTypesAction = ({ type: typeof actionTypes.LOAD_CLINIC_TYPES_SUCCESS } & Payload<ClinicType[]>);

export const loadClinicTypesSuccess = (payload: ClinicType[]): ClinicTypesAction => ({
    payload,
    type: actionTypes.LOAD_CLINIC_TYPES_SUCCESS
});

export const loadClinicTypes = () => async (dispatch: Dispatch) => {
    const result = await loadAndTrack(
        dispatch,
        actionTypes.LOAD_CLINIC_TYPES,
        clinicApi.getClinicTypes());
    dispatch(loadClinicTypesSuccess(result));
};
